import { themeColors } from '@/theme/colors';

export const RightFoot = () => (
  <path
    d='M140.138 455.929C136.388 455.554 131.325 451.431 129.262 454.242C127.199 457.053 127.762 467.734 128.325 472.419C128.887 477.104 128.7 480.102 131.887 481.789C135.075 483.475 141.638 483.101 147.639 483.101C153.64 483.101 164.704 482.913 168.454 481.414C172.204 479.915 170.892 476.542 169.767 474.293C168.642 472.044 164.329 470.358 161.516 468.297C158.506 466.091 155.626 463.713 152.89 461.176C151.202 459.302 153.64 457.615 151.577 456.866C149.514 456.116 143.889 456.491 140.138 455.929Z'
    stroke={themeColors.sensorPlacementOutline}
    strokeWidth='1.87457'
  />
);
